/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Calendar_Ical_Only_OwnInputs */

const cs_settings_calendar_ical_only_own = /** @type {(inputs: Settings_Calendar_Ical_Only_OwnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iCal obsahuje jen vaše exportovatelné úkoly — nikdy úkoly kolegů.`)
};

const en_settings_calendar_ical_only_own = /** @type {(inputs: Settings_Calendar_Ical_Only_OwnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The iCal feed only includes your own exportable tasks — never teammates.`)
};

/**
* | output |
* | --- |
* | "The iCal feed only includes your own exportable tasks — never teammates." |
*
* @param {Settings_Calendar_Ical_Only_OwnInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_calendar_ical_only_own = /** @type {((inputs?: Settings_Calendar_Ical_Only_OwnInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Calendar_Ical_Only_OwnInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_calendar_ical_only_own(inputs)
	return cs_settings_calendar_ical_only_own(inputs)
});